import { useFetchOrchestrationProgress } from '../../hooks/useFetchOrchestrationProgress';
import * as Styled from './ProgressCell.styled';

interface ProgressCellProps {
  orchestrationId: string | null | undefined;
  isRunning: boolean;
  isFailed: boolean;
}

export const ProgressCell = ({
  orchestrationId,
  isRunning,
  isFailed,
}: ProgressCellProps) => {
  const { data: progress } = useFetchOrchestrationProgress(
    orchestrationId,
    isRunning,
  );

  const percentComplete = progress?.percentage_completed ?? 0;

  return (
    <Styled.Container>
      {orchestrationId && !isFailed ? (
        <>
          <Styled.StyledLinearProgress
            variant="determinate"
            value={isRunning ? percentComplete : 100}
          />
          <Styled.StyledTypography variant="caption">
            {isRunning ? `${percentComplete.toFixed(1)}%` : '100%'}
          </Styled.StyledTypography>
        </>
      ) : null}
    </Styled.Container>
  );
};
